import Spinner from '../Spinner'

interface LuckyInfo {
  date: string
  day_gan: string
  day_ji: string
  lucky_color: string
  lucky_number: number
  lucky_direction: string
  lucky_food: string
  advice: string
}

interface Props {
  lucky: LuckyInfo | null
  loading?: boolean
}

export default function DailyFortuneReceipt({ lucky, loading }: Props) {
  if (loading) {
    return (
      <div className="bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl p-5 flex items-center justify-center h-48">
        <div className="text-center">
          <Spinner />
          <p className="text-[var(--color-text-tertiary)] text-xs mt-2">계산 중입니다... 🏪</p>
        </div>
      </div>
    )
  }

  if (!lucky) return null

  const rows = [
    { label: '행운 색상', value: lucky.lucky_color },
    { label: '행운 숫자', value: String(lucky.lucky_number) },
    { label: '행운 방향', value: lucky.lucky_direction },
    { label: '행운 음식', value: lucky.lucky_food },
  ]

  return (
    <div className="bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl overflow-hidden font-mono">
      {/* 영수증 헤더 */}
      <div className="bg-[var(--color-primary)] text-center py-4 px-4">
        <p className="text-[var(--color-accent)] font-bold text-base">🏪 운명편의점</p>
        <p className="text-[var(--color-secondary)] text-xs mt-0.5">{lucky.date} ({lucky.day_gan}{lucky.day_ji}일)</p>
      </div>

      <div className="px-5 py-4">
        {/* 항목들 */}
        <div className="space-y-2.5 mb-4">
          {rows.map((r) => (
            <div key={r.label} className="flex items-center justify-between">
              <span className="text-[var(--color-text-tertiary)] text-sm">{r.label}</span>
              <span className="text-[var(--color-text-primary)] font-semibold text-sm">{r.value}</span>
            </div>
          ))}
        </div>

        <hr className="receipt-divider my-3" />

        {/* 오늘의 한마디 */}
        <div>
          <p className="text-xs text-[var(--color-text-tertiary)] mb-1.5">오늘의 한마디</p>
          <p className="text-[var(--color-text-primary)] text-sm leading-relaxed italic">"{lucky.advice}"</p>
        </div>

        <hr className="receipt-divider my-3" />

        <p className="text-center text-[var(--color-text-tertiary)] text-xs">* 내일 또 오세요 🏪</p>
      </div>
    </div>
  )
}
